import { Box, IconInfoOutlined, Typography } from '@capitalise/ui-design-system';

const ErrorScreen = () => {
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        gridGap="3xsmall"
      >
        <Box py="large">
          <IconInfoOutlined width={80} height={80} color="danger" />
        </Box>
        <Typography size="heading-28" color="grey-900">
          We were unable to generate this report
        </Typography>
        <Typography size="body-16" color="grey-800">
          Sorry, we were unable to prepare this report for you, please try again or contact us.
        </Typography>
      </Box>
    </>
  );
};

export default ErrorScreen;
